module.exports = __webpack_public_path__ + "static/media/19@2x.efc13c39.png";